import { render, staticRenderFns } from "./PremiumYearly.vue?vue&type=template&id=9c1381f2&"
import script from "./PremiumYearly.vue?vue&type=script&lang=js&"
export * from "./PremiumYearly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports